import * as faceapi from '@vladmandic/face-api'
import * as tf from '@tensorflow/tfjs'

export type LoadedModels = {
  ready: boolean
}

let modelsLoaded = false

export async function loadFaceModels(basePath: string = '/models'): Promise<LoadedModels> {
  if (modelsLoaded) return { ready: true }
  try {
    await tf.setBackend('webgl')
    await tf.ready()
  } catch {
    // ignore and use default backend
  }
  await faceapi.nets.tinyFaceDetector.loadFromUri(basePath)
  // Landmarks/recognition/expressions are intentionally not loaded for performance
  modelsLoaded = true
  return { ready: true }
}

export async function detectFaces(video: HTMLVideoElement) {
  const options = new faceapi.TinyFaceDetectorOptions({ inputSize: 160, scoreThreshold: 0.5 })
  const detection = await faceapi.detectSingleFace(video, options)
  return detection ? [detection] : []
}

export { faceapi }


